import Vue from 'vue'
import App from './App.vue'
import router from './router'
import 'dtoaster/dist/dtoaster.css'
import DToaster from 'dtoaster'

Vue.use(DToaster, {
  position: 'bottom-right', 
  containerOffset: '0px',
})

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
